import React, { useEffect, useState } from "react";
import api from "../api/client";
import { Pulse } from "@phosphor-icons/react";

const actionColor = {
  "user.login": "bg-blue-50 text-blue-700 border-blue-200",
  "user.register": "bg-amber-50 text-amber-700 border-amber-200",
  "user.approve": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "user.disable": "bg-red-50 text-red-700 border-red-200",
  "lender.create": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "lender.update": "bg-blue-50 text-blue-700 border-blue-200",
  "lender.delete": "bg-red-50 text-red-700 border-red-200",
  "deal.analyze": "bg-purple-50 text-purple-700 border-purple-200",
  "deal.recommend": "bg-slate-100 text-slate-700 border-slate-200",
  "file.upload": "bg-amber-50 text-amber-700 border-amber-200",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setLogs(data || [])).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-semibold mb-2">Admin</div>
        <h1 className="font-heading text-4xl font-bold tracking-tighter">Audit log</h1>
        <p className="text-slate-600 mt-1">Every meaningful action across the platform.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[11px] uppercase tracking-[0.15em] text-slate-500">
            <tr>
              <th className="text-left px-6 py-3 font-semibold">When</th>
              <th className="text-left px-6 py-3 font-semibold">Actor</th>
              <th className="text-left px-6 py-3 font-semibold">Action</th>
              <th className="text-left px-6 py-3 font-semibold">Target</th>
              <th className="text-left px-6 py-3 font-semibold">Details</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan="5" className="px-6 py-10 text-center text-slate-500"><Pulse size={24} className="inline mr-2 text-slate-400" />No audit events yet.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-slate-200 hover:bg-slate-50">
                <td className="px-6 py-3 font-mono text-xs text-slate-700 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                <td className="px-6 py-3 text-xs">{l.actor_email}</td>
                <td className="px-6 py-3"><span className={`text-[10px] uppercase tracking-[0.12em] font-semibold px-2 py-0.5 rounded border ${actionColor[l.action] || "bg-slate-100 text-slate-700 border-slate-200"}`}>{l.action}</span></td>
                <td className="px-6 py-3 font-mono text-xs">{l.target_type}{l.target_id ? `:${String(l.target_id).slice(0, 8)}` : ""}</td>
                <td className="px-6 py-3 text-xs text-slate-600 max-w-md truncate">{l.details ? JSON.stringify(l.details) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
